import PropTypes from 'prop-types';
import { ArrowDown, ArrowUp } from 'assets/images';

export function ExpandedArrowIcon({ expandable, expanded, record, onExpand }) {
  if (!expandable) {
    return null;
  }

  if (expanded) {
    return <ArrowUp data-testid="arrow-up" onClick={() => onExpand(record)} />;
  }

  return (
    <ArrowDown data-testid="arrow-down" onClick={() => onExpand(record)} />
  );
}

ExpandedArrowIcon.propTypes = {
  expandable: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired,
  record: PropTypes.shape({}).isRequired
};
